import React, { useContext, useRef,useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Dropdown, Modal } from "antd";
import { notChromeMessage, storage } from "@/util";
import StateContext from "@/MyStateContext"
import { useReducer ,useState } from 'react';
import { Action, reducer, initialState } from '@/Action';
import * as consts from "@/config/const";
import {  RoleCode } from "@/types";
 import { checkPlayTips } from "@/api/conference";
import debounce from 'lodash/debounce';
import {
  LOGININFOSTORE,
  METTINGPAGE_SAVED_MEETING_INFO,
  NORMALSETTINGKEY,
} from "@/config/const";
import {
  // ControlOutlined,
  UserAddOutlined,
  MoreOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import {eventEmitter} from "@/hooks/use-rtc"
import { ConferenceInterface } from "@/types";
import Icon from "@/component/Icon";
import {
  AudioIcon,
  VideoIcon,
  ShareIcon,
  SoundIcon,
  CloseSquareIcon,
} from "@/component/ToggleIcon";
import RoomClient from "../../../qrtc_web_sdk/RoomClient100";
import Btn from "./Btn";
import { MeetingContext } from "@/pages/Meeting";
import style from "./style.module.scss";
import Cmenu from "@/component/Menu";
import useDevices from "@/hooks/use-device";
import { inElectron } from "@/util";
import { selectSource, closeStream } from "@/util/electronShare";
import { Image, Button } from "antd";
import { Tabs, Row, Col, Card, Spin } from "antd";
import * as _ from "lodash";
import useWindowSize from "@/hooks/use-window";
import useQuery from "@/hooks/use-query";
import { conference, record } from "@/api";
import { BoolType, Commond } from "@/types";
import { useAuth } from "@/component/Auth";
import { info } from "console";
import { set } from "js-cookie";
import userAddIcon from "../../../assets/images/user-add.svg";
import recordIcon from "../../../assets/images/record-circle.svg";
import exitIcon from "../../../assets/images/logout.svg";

const { TabPane } = Tabs;
const { Meta } = Card;

const electron = (window as any).electron;

interface PropType {
  showParticipants: () => void;
  open: (v: string) => void;
}
let roomClient: RoomClient;
const Footer = (props: PropType) => {
  const [showApplyTobeHostButton, setShowApplyTobeHostButton] = useState(false);

  const { showParticipants, open } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const { participants, service } = useContext(MeetingContext);
  const { winWidth, winHeight } = useWindowSize();

  const { speaker: querySpeaker } = useQuery();

  const history = useHistory();

  const [videos, setVideos] = React.useState([]);

  const [modelShow, setModelShow] = React.useState(false);
  const [sourceList, setSourceList] = React.useState([]);
  const [selectedSource, setSelectedSource] = React.useState({});
  const [streamSrc, setStreamSrc] = React.useState({});
  const [isSpining,setIsSpining]=React.useState(false);
  const videoRef = useRef(null);

  const [audios, setAudios] = React.useState([]);
  const [mics, setMics] = React.useState([]);

  const [videoSelect, setVideoSelect] = React.useState("");
  const [audioSelect, setAudioSelect] = React.useState("");
  const [micSelect, setMicSelect] = React.useState("");
  const [sharing, setSharing] = React.useState(false);
  // const { dispatch } = useContext(StateContext);

  const auth = useAuth();
  const { loggedIn, loginfo, updateLogInfo } = auth;

  let {conference: conf} = useContext(MeetingContext);

  const checkDevice = async () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { videos, mics, audios } = await useDevices();

    if (videos.length) setVideoSelect(videos[0].deviceId);
    setVideos(videos);

    if (mics.length) setMicSelect(mics[0].deviceId);
    setMics(mics);

    if (audios.length) setAudioSelect(audios[0].deviceId);
    setAudios(audios);
  };

  React.useEffect(() => {
     me.audio = true
    checkDevice();
  }, []);
  React.useEffect(() => {
    const handleHostLeaveMeeting = () => {
      setShowApplyTobeHostButton(true);
    };

    eventEmitter.on('hostLeaveMeeting', handleHostLeaveMeeting);

    // 在组件卸载时移除事件监听器
    return () => {
      eventEmitter.off('hostLeaveMeeting', handleHostLeaveMeeting);
    };
  }, []);
  const choiceDevice = async (type: string, id: string) => {
    if (type === "mic") {
      setMicSelect(id);
      await service.setCurrentMic(id);
    } else if (type === "audio") {
      setAudioSelect(id);
      await service.setCurrentSpeaker(id);
      // service.setAudioPlayoutVolume(100);
    } else {
      setVideoSelect(id);
      await service.setCurrentCameraDevice(id);
    }
  };

  const micsItems = React.useMemo(() => {
    return mics.map((x) => ({
      k: x.deviceId,
      v: x.label || x.deviceId,
    }));
  }, [mics]);

  const micsMenu = React.useMemo(() => {
    return (
      <Cmenu
        items={micsItems}
        selectedItems={[micSelect]}
        onSelect={(v) => choiceDevice("mic", v)}
        title="Микрофон сонгох"
        single
      />
    );
  }, [micSelect, micsItems]);

  const audioItems = React.useMemo(() => {
    return audios.map((x) => ({
      k: x.deviceId,
      v: x.label || x.deviceId,
    }));
  }, [audios]);

  const audiosMenu = React.useMemo(() => {
    return (
      <Cmenu
        items={audioItems}
        selectedItems={[audioSelect]}
        onSelect={(v) => choiceDevice("audio", v)}
        title="Спикер сонгох"
        single
      />
    );
  }, [audioItems, audioSelect]);

  const videoItems = videos.map((x) => ({
    k: x.deviceId,
    v: x.label || x.deviceId,
  }));

  const videoMenu = (
    <Cmenu
      items={videoItems}
      selectedItems={[videoSelect]}
      onSelect={(v) => choiceDevice("video", v)}
      title="Камер сонгох"
      single
    />
  );

  const shareItem = [
    { k: "screen", v: "Дэлгэцээ хуваалцах", c: true },
    // { k: "board", v: "白板共享", c: true },
  ];

  const selectShare = (v: string) => {
    
    if (v === "screen"){
      if (inElectron()){
        showShareModal();
      }else{
        service.openShare();
      }     
    } 
    open(v);
  };

  const shareMenu = (
    <Cmenu items={shareItem} selectedItems={[]} onSelect={selectShare} />
  );

  const me = participants[0];
// 带宽先做， 场景突变 
const leave = useCallback(debounce(() => {
  // 你的代码
  console.log("entering leave method")
  const params={
    roomId:conf.roomId,
    conferenceNo: conf.conferenceNo,
    peerId:me.peerId,
    conferenceToken:conf["X-Conference-Token"],
  }
  
  const modal = Modal.confirm({
    title: "Сануулга",
    content: "Өрөөнөөс гарахдаа итгэлтэй байна уу?",
    okText: "Тийм",
    cancelText: "Үгүй",
    onOk: async () => {
      
      const conf: ConferenceInterface = storage.get(
        METTINGPAGE_SAVED_MEETING_INFO
      ); 
      
      //dang qian 时间交给 golang 服务端生成处理
      // conference.compareCurrentTimeWithEndTime(params.roomId,conf.conferenceNo,conf.endTime).then((res)=>{
      //   ;
      //   console.log("比较当前时间和预约会议结束时间:",res);
      // })
      console.log("leaveConference params:::::",params )
      conference.leaveConference(params.roomId, params.peerId, params.conferenceToken, params.conferenceNo).then((resyueye)=>{
        console.log("entering leaveConference ",resyueye)
         
        var currParticipant = state.CurrParticipant;
        // currParticipant=storage.get(consts.CurrParticipant);
        console.log("leaveConference:::::",currParticipant.roleCode)
        console.log("roleCode:::::",me.roleCode)
        roomClient = new RoomClient();
        if(me.roleCode===RoleCode.host ){
          // participants.filter(participant => participant.peerId !== params.peerId);
          const index = participants.findIndex(participant => participant.peerId === params.peerId);

        if (index !== -1) {
          participants.splice(index, 1);
        }

          console.log("host leave !!!!!!!!!!!:::::",me.roleCode)
          // hostLeaveMeeting();
          // roomClient.sendHostLeaveMsg(10, "host leave");
          
          // roomClient.sendCustomCmdMsg(10, "host leave");
        } else {
          //   
          // roomClient.sendHostLeaveMsg(11, "host not leave");
          console.log("host not leave" )
        }
       
        const getMeetings = async () => {
          const params = {
            pageNum: 0,
            pageSize: 100,
            param: {},
          };
          const ret = await conference.orderList(params);
          console.log(ret)
            
          // dispatch({type:"SetMeetingRecords", ret})
            
        };
        console.log(resyueye);
        const conferenceNo = storage.get("thisisakeyforsavemeetinginfo").conferenceNo;
        //如果是预约会议，检查当前时间是否已经超过了预约的结束时间
        
        //check if no persion in room first
        conference.countOngoingUserAmt( conferenceNo,params.roomId).then((res)=>{
          console.log("entering countOngoingUserAmt")
          console.log("countOngoingUserAmt"+res);
          if (!resyueye.data && res && !res.data    ){
            
            conference.updateEndTime(conferenceNo,params.roomId).then((resx)=>{
             
              conference.forceEnd(params.roomId).then((res)=>{
                 
               
                console.log("MoveOngoingToHistoryConference:::",res);
                // orderList
                getMeetings()
                  service.close();
                  console.log(" Нүүр хуудас руу шилжүүлэх")
                  // history.goBack(); 
                  history.replace("/");
                  // history.push('/previous-page');
                 modal.destroy(); // 关闭Modal 硬件抽象 
              })
            })
            
          } else {
            console.log("still have user in room:",res.data);
           
            console.log("It’s not the end time yet",resyueye.data);
            // if(res.data[0].exitTime==="0001-01-01T00:00:00Z"){
            //   console.log("结束时间非法")
            //   conference.updateEndTime(conferenceNo,params.roomId).then((resx)=>{
            //     console.log("updateEndTime",resx)
            //     conference.forceEnd(params.roomId).then((res)=>{
            //         console.log("MoveOngoingToHistoryConference:::",res);
            //     })
            //   })

            // }
          }
        })
         
    });
      await service.close();
      console.log("Нүүр хуудас руу шилжүүлэх")
      // await history.goBack();
      history.replace("/");
       modal.destroy(); // 关闭Modal
    },
  });
}, 1000), []);
  

  const [speaker, setSpeaker] = React.useState(querySpeaker === "true");

  const speakerClick = () => {
    service.setAudioPlayoutVolume(speaker ? 0 : 100);
    setSpeaker(!speaker);
  };

  const getInputSources = async (func: any) => {
    if (inElectron()) {
      let res = await electron.showSharewWin();
      let resGp = _.toPairsIn(_.groupBy(res, (item) => item.id.substr(0, 6)));
      setSourceList(resGp);
      func();
    }
  };

  const showShareModal = () => {
      setIsSpining(true);
      getInputSources(() => {
      setIsSpining(false);
      setModelShow(true);
    });
  };

  const hideShareModal = () => {
    setModelShow(false);
  };

  const shareCapture = async () => {
    let streamSrc = await selectSource(selectedSource);
    service.openElectronShare(streamSrc);
    setStreamSrc(streamSrc);
    setSharing(true);
    setModelShow(false);
  };

  const closeShareCapture = async () => {
    closeStream(streamSrc);
    service.closeElectronShare();
    setSharing(false);
  };
//<Btn icon={<ShareIcon active={true} />} onClick={showShareModal}>
  const sharingBtn = () => {
    if (inElectron()) {
      if (sharing) {
        return (
          <Btn
            icon={<CloseSquareIcon active={false} />}
            onClick={closeShareCapture}
          >
            {" "}
            Унтраах
          </Btn>
        );
      } else {
        return (
          <Btn icon={<ShareIcon active={true} />} dropdown={shareMenu}>
            {" "}
            Хуваалцах
          </Btn>
        );
      }
    } else {
      return (
        <Btn icon={<ShareIcon active={true} />} dropdown={shareMenu}>
          Хуваалцах
        </Btn>
      );
    }
  };

  const selSource = (e: any, source: any) => {
    setSelectedSource(source);
  };

  const startRecording = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.startRecord,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
    
  };

  const stopRecording = () => {
     
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    record.recordComplete(  {
        peerId:me.peerId,
        roomId:conf.roomId,
    }).then((res)=>{
      console.log("recordComplete",res)
    })
    conference.conferenceControl(
      {
        command: Commond.stopRecord,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer,
       
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const pauseRecording = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.pauseRecording,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const resumeRecording = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.resumeRecording,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const startStreaming = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.startStreaming,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const stopStreaming = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.stopStreaming,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const resumeStreaming = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.resumeStreaming,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };
  const hostLeaveMeeting = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.hostLeaveMeeting,
        metadata: "hostLeaveMeeting!!!!!",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
    
  }
  const pauseStreaming = () => {
    const fromPeer = {
      peerid: me.peerId,
      deviceid: 8,
    };
    conference.conferenceControl(
      {
        command: Commond.pauseStreaming,
        metadata: "",
        seq: "",
        room: conf.roomId,
        from: fromPeer
      },
      {
        "X-Conference-No": conf.conferenceNo,
        "X-Channel-Token": conf["X-Channel-Token"],
        "X-Conference-Token": conf["X-Conference-Token"],
      }
    );
  };

  const getaudioStatus = () => {
    return participants[0].audio;
    //error
    // const info = storage.get(METTINGPAGE_SAVED_MEETING_INFO)  
    
    // const me = {
    //   audio: true,
      
    // };
    // if(info && !info.muteJoinMeeting){
    //     me.audio = true;
    // } else {
    //   me.audio = false;
    // }
    
  
    // console.log("audio status:" + me.audio);
  
 
    // return me.audio;
  };
  
  return (
    <div className={style.container}>
      <Btn
        // icon={<AudioIcon active={true} />}
        // @ts-ignore
        icon={<AudioIcon active={ getaudioStatus()} />}
        // muteJoinMeeting
        onClick={() => {
          if (me.audio) {
            service.stopLocalAudio();
          } else {
              let conferenceNo=   conf.conferenceNo
              //获取会意信息
              checkPlayTips(conferenceNo).then((res:any)=>{
                 
                console.log("conferenceInfo:",res)
                if(res.allowSelfUnmute){
                  service.startLocalAudio();
                }
              })
            
              
          }
        }}
        // onClick={ service.startLocalAudio  }
        dropdown={micsMenu}
        hover={false}
      >
        Микрофон
      </Btn>
      <Btn
        icon={<SoundIcon active={speaker} />}
        onClick={speakerClick}
        dropdown={audiosMenu}
        hover={false}
      >
        Спикер
      </Btn>
      <Btn
        icon={<VideoIcon active={me.video} />}
        onClick={
          me.video ? service.stopLocalPreview : service.startLocalPreview
        }
        dropdown={videoMenu}
        hover={false}
      >
        Камер
      </Btn>
      <Btn icon={<img style={{ width: "16px" }} src={userAddIcon} alt="userAddIcon" />} onClick={showParticipants}>
        Оролцогчид
        <small
          style={{
            position: "absolute",
            top: -24,
            right: 0,
            fontWeight: "bold",
          }}
        >
          {participants.length}
        </small>
      </Btn>

      {sharingBtn()}

      {/* {loggedIn && (<Btn
        icon={<img style={{ width: "16px" }} src={recordIcon} alt="recordIcon" />}
        onClick={me.recording ? stopRecording : startRecording}
      >{me.recording ? `Рекорд дуусгах` : `Рекорд`}
      </Btn>)} */}
      {/* {me.recording ? (<Btn
        icon={<Icon type="icon-recording" />}
        onClick={me.recordingPaused ? resumeRecording : pauseRecording}
      >
        {me.recordingPaused ? `继续录制` : `暂停录制`}
      </Btn>) : null
      } */}
    
{/* 开始直播 */}
      {/* {loggedIn && (<Btn
        icon={<Icon type="icon-recording" />}
        onClick={me.livestreaming ? stopStreaming : startStreaming}
      >
        {me.livestreaming ? `停止直播` : `开始直播`}
      </Btn>)
      } */}

      {/* {me.livestreaming ? (<Btn
        icon={<Icon type="icon-recording" />}
        onClick={me.isLiveStreamingPaused ? resumeStreaming : pauseStreaming}
      >
        {me.isLiveStreamingPaused ? `继续直播` : `暂停直播`}
      </Btn>) : null} */}

      
      <Btn
        icon={<img style={{ width: "16px" }} src={exitIcon} alt="exitIcon" />}
        onClick={leave}
        style={{ float: "right" , width: "80px"}}
      >
        Гарах
      </Btn>
      {showApplyTobeHostButton && (
        <Btn 
        icon={<PhoneOutlined className="color-danger" rotate={125} />}
        style={{ float: "right" }}
        onClick={() => {
          // 在这里处理按钮的点击事件
           setShowApplyTobeHostButton(false);
        }}>
          Host болох хүсэлт илгээх
        </Btn>
      )}
      <Modal  visible={isSpining} footer={null}>
        <Spin/>
      </Modal>
      <Modal
        title="Share list"
        centered
        width={winWidth / 3}
        visible={modelShow}
        onOk={shareCapture}
        onCancel={hideShareModal}
        okText="Хуваалцах"
        cancelText="Болих"
      >
        <Tabs defaultActiveKey="1">
          {sourceList.map((sourceSubs, j) => {
            return (
              <TabPane
                tab={sourceSubs[0]=='screen'?'Screen':'Window'}
                key={j}
                style={{ height: winHeight / 3, overflowY: "scroll" }}
              >
                <Row>
                  {sourceSubs[1].map((source: any, key: number) => {
                    return (
                      <Col span={8} key={key}>
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            selSource(e, source);
                          }}
                          style={
                            selectedSource == source
                              ? {
                                  backgroundColor: "black",
                                  borderRight: "3px solid",
                                  marginLeft: "1em",
                                }
                              : { marginLeft: "1em" }
                          }
                        >
                          <Image
                            width={160}
                            height={100}
                            preview={false}
                            src={source.img}
                          />
                          <p style={{ textAlign: "center" }}>{source.name}</p>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </TabPane>
            );
          })}
        </Tabs>
        {/* <video crossOrigin="anonymous" width="500" autoPlay ref={videoRef}></video> */}
      </Modal>
    </div>
  );
};

export default Footer;
